import { NgModule, type ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import { NgPrincipleAccountingModule } from '@principle-theorem/ng-principle-accounting';
import {
  CLAIM_ESTIMATE_PROVIDER,
  InformationBoxComponent,
} from '@principle-theorem/ng-principle-shared';
import { LoaderButtonComponent } from '@principle-theorem/ng-shared';
import { DepositPaymentNoticeComponent } from './invoice-transactions/deposit-payment-notice/deposit-payment-notice.component';
import { InvoiceTransactionsComponent } from './invoice-transactions/invoice-transactions.component';
import { PaymentPlanComponent } from './methods/payment-plan/payment-plan.component';
import {
  NG_PAYMENTS_CONFIG,
  type INgPaymentsConfig,
} from './ng-payments-config';
import { PayInvoiceComponent } from './pay-invoice/pay-invoice.component';
import { TransactionsModule } from './transactions/transactions.module';
import { ClaimEstimateProviders } from './transactions/transaction-providers/claim-estimate/claim-estimate-providers.service';

@NgModule({
  imports: [
    NgPrincipleAccountingModule,
    TransactionsModule,
    NgMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    InformationBoxComponent,
    LoaderButtonComponent,
  ],
  declarations: [
    PaymentPlanComponent,
    PayInvoiceComponent,
    InvoiceTransactionsComponent,
    DepositPaymentNoticeComponent,
  ],
  exports: [
    TransactionsModule,
    PayInvoiceComponent,
    InvoiceTransactionsComponent,
  ],
})
export class NgPaymentsModule {
  static forRoot(
    config: INgPaymentsConfig
  ): ModuleWithProviders<NgPaymentsModule> {
    return {
      providers: [
        {
          provide: CLAIM_ESTIMATE_PROVIDER,
          useExisting: ClaimEstimateProviders,
        },
        {
          provide: NG_PAYMENTS_CONFIG,
          useValue: config,
        },
      ],
      ngModule: NgPaymentsModule,
    };
  }
}
